import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xegqzmw7gz: FaireBrandEntity = {
  token: "b_xegqzmw7gz",
  type: "brand",
  name: "Tumbleweed Design Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/05d300238f10aa1b838c9940b2b5d956fcdcd782f5b92a23b137ccedad3687b0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3cbe5bd2b846036b909e72c25d446123ac9c1a4260c0c2f9d5cf9f93a6bdfdf0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/05d300238f10aa1b838c9940b2b5d956fcdcd782f5b92a23b137ccedad3687b0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3cbe5bd2b846036b909e72c25d446123ac9c1a4260c0c2f9d5cf9f93a6bdfdf0.jpeg",
  location: "Long Beach, CA, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 19,
  isTopShop: true,
  isInsider: true,
  description:
    "I'm Bri, founder of Tumbleweed Design Studio, an illustrator and designer based in Southern California. I'm drawn to the beauty of imperfection - what I like to call \"perfectly imperfect\" - and love incorporating hand-drawn elements that celebrate the human experience into my art prints. My approach is intentionally simple; I believe that the most meaningful messages don't need an overly complicated delivery.  I create personal work of quirky illustrations that inspire/charm, and I partner with small businesses and brands to create warm and intentional brand designs that connect with their communities. \n\nI explore many interests in my work, but there are three main recurring themes: cowgirls, nature, and wine.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:07.595Z",
    importedBy: "entity-db-cli",
  },
};
